import { useNavigate } from "react-router-dom";
import { ExternalLink, ArrowRight } from "lucide-react";

const STATUS = {
  reviewing: { label: "Reviewing", cls: "bg-gray-100 text-gray-600" },
  designing: { label: "Designing", cls: "bg-[#D4AF37]/15 text-[#B8901F]" },
  "preview-ready": { label: "Preview Ready", cls: "bg-blue-50 text-blue-700" },
  completed: { label: "Completed", cls: "bg-green-50 text-green-700" },
};

export const StatusBadge = ({ status }) => {
  const s = STATUS[status] || STATUS.reviewing;
  return (
    <span className={`text-xs font-semibold px-3 py-1 rounded-full ${s.cls}`} data-testid="build-status-badge">
      {s.label}
    </span>
  );
};

export const StarterBuildCard = ({ build }) => {
  const navigate = useNavigate();
  return (
    <div
      className="bg-white rounded-2xl p-6 border border-gray-100 shadow-[0_4px_20px_rgb(0,0,0,0.03)] hover:shadow-[0_16px_40px_rgb(0,0,0,0.08)] transition-all duration-300"
      data-testid={`build-card-${build.id}`}
    >
      <div className="flex items-start justify-between gap-3 mb-4">
        <div>
          <h3 className="font-display text-lg font-semibold text-[#0F0F0F]">{build.app_name}</h3>
          {build.industry && <p className="text-xs font-medium text-[#D4AF37] mt-0.5">{build.industry}</p>}
        </div>
        <StatusBadge status={build.status} />
      </div>

      <div className="mb-5">
        <div className="flex items-center justify-between text-xs text-[#687280] mb-1.5">
          <span>Progress</span>
          <span className="font-semibold text-[#0F0F0F]">{build.progress}%</span>
        </div>
        <div className="h-2 rounded-full bg-[#F1F1F0] overflow-hidden">
          <div className="h-full bg-[#D4AF37] rounded-full transition-all" style={{ width: `${build.progress}%` }} />
        </div>
      </div>

      <div className="flex gap-3">
        <button
          onClick={() => window.open(build.live_preview_url, "_blank", "noopener,noreferrer")}
          disabled={!build.live_preview_url}
          className="flex-1 inline-flex items-center justify-center gap-2 bg-[#0F0F0F] text-white rounded-full py-2.5 text-sm font-medium hover:bg-[#D4AF37] hover:text-[#0F0F0F] transition-colors disabled:opacity-40"
          data-testid={`build-live-preview-${build.id}`}
        >
          Live Preview <ExternalLink size={14} />
        </button>
        <button
          onClick={() => navigate(`/custom-app/${build.id}`)}
          className="flex-1 inline-flex items-center justify-center gap-2 border border-gray-200 text-[#0F0F0F] rounded-full py-2.5 text-sm font-medium hover:bg-[#F7F7F7] transition-colors"
          data-testid={`build-details-${build.id}`}
        >
          Project Details <ArrowRight size={14} />
        </button>
      </div>
    </div>
  );
};
